import React from "react";

const ReactUtils = (() => {
  const emailRegex = /^[\w-\.\+]+@([\w-]+\.)+[\w-]{2,4}$/;

  return {
    toUrlVars: (paramsObj) =>
      Object.entries(paramsObj)
        .filter(([, value]) => value && value !== "undefined")
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join("&"),

    normalizeWebsite: function (url) {
      if (!url || /^https?/.test(url)) {
        return url;
      }
      return `http://${url}`;
    },

    /**
     * @param {Address} primaryAddress
     */
    formatAddressString: function (address) {
      return ["street1", "street2", "city", "state"]
        .map((prop) => address[prop])
        .filter((datum) => !!datum)
        .join(", ");
    },

    formatAgencyDataAddress: function (address2, city, state, postalCode) {
      return (
        <React.Fragment>
          {address2 && <div>{address2}</div>}
          <div>
            {city || <em>No City Provided</em>}, {state || <em>No State Provided</em>}{" "}
            {postalCode || <em>No ZIP Provided</em>}
          </div>
        </React.Fragment>
      );
    },

    emptyFieldText: () => <em>None Provided</em>,

    sortBy:
      /**
       *
       * @param {string} sorter The field we want to sort objects by
       *         ex: "created_at" (asc sort), "created_at_desc" (desc sort)
       * @param {Object[]} list The list of objects to sort
       */
      function sortBy(sorter, list) {
        list.sort((a, b) => {
          let [first, last] = [a, b].map((elt) => elt[sorter.replace("-desc", "")].toLowerCase());

          if (sorter.includes("createdAt") || sorter.includes("created_at"))
            [first, last] = [first, last].map((d) => new Date(d.toUpperCase()));

          if (sorter.includes("desc")) [first, last] = [last, first];

          return first > last ? 1 : -1;
        });
        return list;
      },

    filterBy:
      /**
       *
       * @param {Object[]} list The list of objects to filter
       * @param {Object[]} filters The fields and their values to filter by
       *        ex: [{ status: "accepted", type: "all" }] (return the objects of status "accepted" and of any type)
       */
      function filterBy(list, filters) {
        let filteredList = list;

        Object.keys(filters).forEach((field) => {
          // Assume that the fields that shouldn't be filtered are set to "all"
          if (filters[field] !== "all") {
            filteredList = filteredList.filter((elt) => elt[field] === filters[field]);
          }
        });

        return filteredList;
      },

    validateDate: (dateString) => {
      if (dateString === "") return true;

      return dateString.match(/^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/) !== null;
    },

    /**
     * Number between 0 and 120
     */
    validateNumber: (numberString) => {
      if (numberString === "") return true;
      return numberString.match(/^(120|1[01][0-9]|[1-9]?[0-9])$/) !== null;
    },

    validatePhoneNumber: (numberString) => {
      const digits = numberString.replace(/\D*/g, "");

      // Check for 10 digits (which is US phone number without country code)
      // The server only allows/checks for 10 digits, so follow that process here.
      return 10 === digits.length;
    },

    validateEmail: (emailString) => {
      return emailRegex.test(emailString);
    },

    formatTimestamp: (dateString) => {
      const date = new Date(dateString);
      const options = { year: "numeric", month: "long", day: "2-digit" };
      return date.toLocaleDateString(undefined, options);
    },
  };
})();

export default ReactUtils;
